import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { connectModal } from 'redux-modal';
import BMXButton from '../../../../Components/Buttons/BMXButton/BMXButton';
import BMXModal from '../../../../Components/Modals/BMXModal/BMXModal';
import NoteForm from '../../Forms/NoteForm/NoteForm';

const NoteModal = (props) => {
  const formName = 'NoteModal';
  const { t } = useTranslation();
  const [step, setStep] = useState(0);
  const [steps, setSteps] = useState([
    { title: t('global:note.addNote'), error: false },
  ]);
  const [isSubmit, setIsSubmit] = useState(false);
  const { handleHide, show, header } = props;


  const buttons = () => {
    return (
      <>
        <BMXButton
          type="subbmit"
          bmxclass="Success"
          onClick={() => setIsSubmit(true)}
          form={formName}
        >
          {t("global:save")}
        </BMXButton>
      </>
    );
  };

  const setErrorHeader = (formNumber, val) => {
    steps[formNumber].error = val;
    setSteps([...steps]);
  };

  return (
    <BMXModal
      activeStep={step}
      setStep={setStep}
      open={show}
      width={'750px'}
      height={'300px'}
      onClose={handleHide}
      header={header}
      buttons={buttons()}
      steps={steps}
    >
      <NoteForm
        steps={steps}
        isSubmit={isSubmit}
        step={step}
        setStep={setStep}
        formName={formName}
        handleHide={handleHide}
        setErrorHeader={setErrorHeader}
        {...props} />
    </BMXModal>
  );
};

export default connectModal({ name: 'NoteModal' })(NoteModal);
